import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import {
  retailerContactAccessControl,
  retailerContactViewAccessControl,
} from '../access-control/retailerContactAccess.configuration'

const RetailerContactPage = lazy(
  () =>
    import(
      /* webpackChunkName: "RetailerContactPage" */
      '../pages/retailer-contact/RetailerContactPage'
    )
)

export const retailerContactRouter = (
  <DomainRoute route="retailer-contact" accessControl={retailerContactAccessControl}>
    <DashSwitch>
      <DomainRoute
        exact
        route="retailer-contact"
        component={RetailerContactPage}
        accessControl={retailerContactViewAccessControl}
      />
    </DashSwitch>
  </DomainRoute>
)
